import {
  ILegalEntityFormPayload,
  ILegalEntityRecord,
  IStateOption,
  LegalEntityFieldErrors,
  LegalEntityFieldUpdates,
  LegalEntityFormField,
} from './types';

const DOCUMENT = 'CREATE_LEGAL_ENTITY_';

const actions = {
  RESET_FORM: `${DOCUMENT}RESET_FORM`,
  CHANGE_FIELD: `${DOCUMENT}CHANGE_FIELD`,
  CHANGE_FIELDS: `${DOCUMENT}CHANGE_FIELDS`,
  TOUCH_ALL: `${DOCUMENT}TOUCH_ALL`,
  LOAD_STATES_REQUEST: `${DOCUMENT}LOAD_STATES_REQUEST`,
  LOAD_STATES_SUCCESS: `${DOCUMENT}LOAD_STATES_SUCCESS`,
  CREATE_REQUEST: `${DOCUMENT}CREATE_REQUEST`,
  CREATE_SUCCESS: `${DOCUMENT}CREATE_SUCCESS`,
  CREATE_ERROR: `${DOCUMENT}CREATE_ERROR`,
  LOAD_REQUEST: `${DOCUMENT}LOAD_REQUEST`,
  LOAD_SUCCESS: `${DOCUMENT}LOAD_SUCCESS`,
  LOAD_ERROR: `${DOCUMENT}LOAD_ERROR`,
  UPDATE_REQUEST: `${DOCUMENT}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${DOCUMENT}UPDATE_SUCCESS`,
  UPDATE_ERROR: `${DOCUMENT}UPDATE_ERROR`,

  resetForm: () => ({ type: actions.RESET_FORM }),

  changeField: (field: LegalEntityFormField, value: string) => ({
    type: actions.CHANGE_FIELD,
    payload: { field, value },
  }),

  changeFields: (updates: LegalEntityFieldUpdates) => ({
    type: actions.CHANGE_FIELDS,
    payload: updates,
  }),

  touchAll: () => ({ type: actions.TOUCH_ALL }),

  loadStatesRequest: () => ({ type: actions.LOAD_STATES_REQUEST }),

  loadStatesSuccess: (data: IStateOption[]) => ({
    type: actions.LOAD_STATES_SUCCESS,
    payload: data,
  }),

  createRequest: (data: ILegalEntityFormPayload) => ({
    type: actions.CREATE_REQUEST,
    payload: data,
  }),

  createSuccess: () => ({ type: actions.CREATE_SUCCESS }),

  createError: (data: { fieldErrors: LegalEntityFieldErrors }) => ({
    type: actions.CREATE_ERROR,
    payload: data,
  }),

  loadRequest: (id: string) => ({
    type: actions.LOAD_REQUEST,
    payload: { id },
  }),

  loadSuccess: (data: ILegalEntityRecord) => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadError: () => ({ type: actions.LOAD_ERROR }),

  updateRequest: (id: string, data: ILegalEntityFormPayload) => ({
    type: actions.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateSuccess: () => ({ type: actions.UPDATE_SUCCESS }),

  updateError: (data: { fieldErrors: LegalEntityFieldErrors }) => ({
    type: actions.UPDATE_ERROR,
    payload: data,
  }),
};

export default actions;
